import AuthService from 'src/common/api/auth.service';
import api from 'src/common/api/client';
import constants from 'src/common/constants';
import { uid, LocalStorage } from 'quasar';
import AccountService from 'src/common/api/account.service';

let intervalId = null;

export async function authenticateWithEmail(
  { commit, dispatch, rootState }, { email, password },
) {
  if (!LocalStorage.has(constants.LOCALSTORAGE_DEVICE_UUID)) {
    await LocalStorage.set(constants.LOCALSTORAGE_DEVICE_UUID, uid());
  }

  const deviceUUID = LocalStorage.getItem(constants.LOCALSTORAGE_DEVICE_UUID);
  const { location } = rootState.application;
  const response = await AuthService.authenticateWithEmail({
    email, password, deviceUUID, location,
  });

  if (response.status === 200) {
    const { bearerToken, account } = response.data;
    await dispatch('setAccessToken', { accessToken: bearerToken });
    await dispatch('saveCredentials', { accessToken: bearerToken, accountId: account.id });
    await dispatch('application/getLocationConfig', null, { root: true });
    commit('updateAccount', { account });
  }
}

export async function authenticateWithPhone({ dispatch, rootState }, { phoneNumber, message }) {
  if (!LocalStorage.has(constants.LOCALSTORAGE_DEVICE_UUID)) {
    await LocalStorage.set(constants.LOCALSTORAGE_DEVICE_UUID, uid());
  }

  const requestUUID = uid();
  const deviceUUID = LocalStorage.getItem(constants.LOCALSTORAGE_DEVICE_UUID);
  const { location } = rootState.application;
  const response = await AuthService.authenticateWithPhone({
    requestUUID, phoneNumber, message, deviceUUID, location,
  });

  if (response.status === 200) {
    await dispatch('getTokenFromAuthentication', { requestUUID });
  }
}

export async function getTokenFromAuthentication({ commit, dispatch }, { requestUUID }) {
  intervalId = setInterval(async () => {
    const response = await AuthService.getTokenFromAuthentication({ requestUUID });
    if (response.status === 200) {
      const { data, status } = response.data;
      if (status !== 'pending') {
        if (status === 'success') {
          clearInterval(intervalId);

          const { bearerToken, account } = data;
          await dispatch('setAccessToken', { accessToken: bearerToken });
          await dispatch('saveCredentials', {
            accessToken: bearerToken,
            accountId: account.id,
          });
          commit('updateAccount', { account });
        }
        else if (status === 'timeout') {
          clearInterval(intervalId);
          throw new Error('Aðgerð rann út á tíma');
        }
        else {
          clearInterval(intervalId);
          throw new Error('Villa við auðkenningu');
        }
      }
    }
  }, 5000);
}

export async function logout({ commit, dispatch }) {
  commit('updateAccount', { account: null });
  await dispatch('deleteCredentials');
}

export async function searchAccountCollection({ commit }, query) {
  const response = await AccountService.searchUserCollection({ params: query });
  if (response && response.status === 200) {
    const accounts = response.data;
    commit('updateAccounts', { accounts });
  }
}

export async function searchAccountTransactions({ commit }, { params }) {
  const response = await AccountService.searchAccountTransactions(params);
  if (response && response.status === 200) {
    commit('setAllTransactions', { transactions: response.data.reverse() });
  }
}

export async function updateAccount({ commit }, { id }) {
  const response = await AccountService.getAccount({ id });

  if (response.status === 200) {
    const account = response.data;
    commit('updateAccount', { account });
  }
}

export async function saveCredentials(context, { accessToken, accountId }) {
  LocalStorage.set(constants.LOCALSTORAGE_ACCESS_TOKEN, accessToken);
  LocalStorage.set(constants.LOCALSTORAGE_ACCOUNT_ID, accountId);
}

export async function deleteCredentials({ dispatch }) {
  await dispatch('setAccessToken', { accessToken: null });
  LocalStorage.remove(constants.LOCALSTORAGE_ACCESS_TOKEN);
  LocalStorage.remove(constants.LOCALSTORAGE_ACCOUNT_ID);
}

export async function loadCredentials({ dispatch }) {
  if (LocalStorage.has(constants.LOCALSTORAGE_ACCESS_TOKEN)) {
    const accessToken = await LocalStorage.getItem(constants.LOCALSTORAGE_ACCESS_TOKEN);
    const accountId = await LocalStorage.getItem(constants.LOCALSTORAGE_ACCOUNT_ID);
    if (accessToken) {
      await dispatch('setAccessToken', { accessToken });

      if (accountId) {
        await dispatch('updateAccount', { id: accountId });
      }
    }
  }
}

export async function setAccessToken(context, { accessToken }) {
  api.axiosConfigDefaults.headers.Authorization = accessToken ? `Bearer ${accessToken}` : '';
  await api.init();
}
